/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { BsArrowRight } from '@react-icons/all-files/bs/BsArrowRight';
import { useEffect, type FC } from 'react';
import { Link } from 'gatsby';
import type {
  ActionButton,
  ProductsEntity,
  bannerCaptionEntry,
} from '../../../@types/gql/home';
import OpacitySlideIn from '../../animation/opacity-slide-in';
import { isVideoOrImage } from '../../../lib/utils';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { ArrowUpRight } from 'lucide-react';
import { useInView } from 'react-intersection-observer';
import VideoBackground from './video-background';
import { Helmet } from 'react-helmet';

interface HomeHeroSectionProps {
  url: string;
  type: string;
  title: string;
  description: string;
  button: ActionButton;
  products: ProductsEntity[];
  bannerCaptions?: bannerCaptionEntry[];
}

const HomeHeroSection: FC<HomeHeroSectionProps> = ({
  url,
  type,
  title,
  description,
  button,
  products,
  bannerCaptions,
}) => {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplaySpeed: 3000,
    autoplay: true,
    loop: true,
  };

  const { ref: heroRef, inView: heroInView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  useEffect(() => {
    if (isVideoOrImage(type) === 'video') {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'video';
      link.href = url;
      document.head.appendChild(link);
    }
  }, [type, url]);

  const posterUrl = `${url.split('.').slice(0, -1).join('.')}_poster.jpg`;

  return (
    <>
      <div className="relative z-10" ref={heroRef}>
        <div
          className="absolute left-0 top-0 bottom-0 right-0 -z-10"
          ref={heroRef}
        >
          {heroInView ? (
            <>
              {isVideoOrImage(type) === 'video' ? (
                <VideoBackground url={url} posterUrl={posterUrl} />
              ) : (
                <img
                  alt="hero"
                  className="absolute inset-0 -z-10 h-full w-full object-cover"
                  src={url}
                  width={1600}
                  height={900}
                />
              )}
            </>
          ) : null}
        </div>
        <div className="bg-black/75 h-64 sm:h-80 md:h-96 lg:h-[900px] xl:h-[900px] flex items-center">
          <div className="py-36 container px-6 mx-auto max-md:pt-28 max-sm:pt-2 max-sm:pb-0">
            <div className="text-gray-50 max-w-6xl">
              <OpacitySlideIn slideFrom={{ x: 0, y: 100 }}>
                <div className="sliderContainer max-sm:pt-0 pt-14 md:pt-0">
                  <Slider {...settings}>
                    {bannerCaptions?.map(({ id, Title, Description }) => {
                      return (
                        <div key={id}>
                          <h1 className="!text-md md:text-2xl lg:text-4xl font-semibold">
                            {Title}
                          </h1>
                          <p className="mt-5 mb-5 text-md  md:!text-3xl lg:text-[20px] font-light !leading-6 md:!leading-10">
                            {Description}
                          </p>
                        </div>
                      );
                    })}
                  </Slider>
                </div>

                <Link
                  className="bg-action-btn2 py-2 px-6 flex space-x-2 items-center text-lg
                  transition-smooth mt-7 hover:scale-105 hover:-translate-y-1 hover:shadow-lg w-fit rounded-md max-lg:text-sm"
                  to={button.URL}
                >
                  <span>{button.Name}</span>
                </Link>
              </OpacitySlideIn>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          backgroundColor: '#f7f7f7',
        }}
      >
        <div className="container px-6 mx-auto pt-16 pb-7">
          <OpacitySlideIn
            className="flex mb-8 relative"
            slideFrom={{ x: 0, y: 10 }}
          >
            <h2 className="text-4xl font-bold max-w-xl leading-tight mt-6 flex-1 whitespace-pre-wrap max-lg:text-2xl max-md:mt-0">
              Products we Manufacture
            </h2>
            <Link
              className="py-2 px-3 bottom-0 flex h-11 absolute right-0 space-x-1 font-bold text-base items-center transition-smooth rounded-md w-fit border border-red-600 text-red-600 max-md:relative max-lg:text-sm"
              to={button.URL}
            >
              <span>VIEW ALL</span>
            </Link>
          </OpacitySlideIn>
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            <Helmet>
        <link rel="preconnect" href="https://res.cloudinary.com" crossOrigin="anonymous" />
        <link
          rel="preload"
          href={`https://res.cloudinary.com/dm9jlzzyl/image/fetch/f_webp,q_auto,w_500,h_300/${encodeURIComponent(products[0].Thumbnail.url)}`}
          as="image"
        />
      </Helmet>
              {products.map(({ Thumbnail, Title, SubCategory }, index) => {
                const imageUrl = `https://res.cloudinary.com/dm9jlzzyl/image/fetch/f_auto,q_auto,w_500,h_300/${encodeURIComponent(Thumbnail.url)}`;
                if (!SubCategory) {
                  return null;
                }

                try {
                  return (
                    <Link
                      className="product-card"
                      key={SubCategory.Slug}
                      to={`${SubCategory.Category.Slug}/${SubCategory.Slug}`}
                    >
                      <div
                        className="rounded-2xl shadow-xl transition-all border border-zinc-400/25 overflow-hidden bg-white shine flex flex-col h-full"
                        id="product-card-hovered"
                        title={Title}
                      >
                        <div className="product-image-container group">
                          <div className="p-2">
                            <img
                              src={imageUrl}
                              alt={Title}
                              loading={index === 0 ? 'eager' : 'lazy'}
                              fetchPriority={index === 0 ? 'high' : 'auto'}
                              width="500"
                              height="300"                              
                            />
                          </div>
                        </div>
                        <div className="p-4 space-y-1 flex-grow">
                          <span className="text-orange-500 text-xs px-0 py-1 uppercase font-semibold rounded mb-5 tracking-[.15em]">
                            Featured
                          </span>
                          <div className="flex gap-5 items-center justify-between">
                            <h2 className="text-3xl !leading-8 font-bold text-black  mb-0 font-roboto uppercase lg:w-[13rem]">
                              {SubCategory.Title}
                            </h2>
                            <ArrowUpRight
                              size={26}
                              className="text-orange-500 flex-shrink-0"
                            />
                          </div>
                        </div>
                      </div>
                    </Link>
                  );
                } catch (error) {
                  return <p>{Title}</p>;
                }
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeHeroSection;
